"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SGWTConnectError = void 0;
var ErrorList = require("./SGWTConnectErrorList");
/**
 * SGWTConnect error.
 *
 * The purpose of this class is to differentiate custom SGWTConnect
 * errors from errors originated in other modules.
 */
var SGWTConnectError = /** @class */ (function (_super) {
    __extends(SGWTConnectError, _super);
    function SGWTConnectError(code) {
        var _this = this;
        var errorListKey = "ERR_".concat(code.toUpperCase(), "_DESCRIPTION");
        var description = ErrorList[errorListKey];
        _this = _super.call(this, "SGWTConnectError ".concat(code.toUpperCase(), " ").concat(description)) || this;
        // Calling `super` in TypeScript 2.1 and 2.2 breaks the
        // prototype chain, so we need to restore it here to
        // enable instanceof checks
        // See: https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#typescript-21
        Object.setPrototypeOf(_this, SGWTConnectError.prototype);
        // We use the same approach as NodeJS errors by exposing
        // a `code` property (e.g. "state_mismatch") on error
        // instances:
        _this.code = code;
        return _this;
    }
    return SGWTConnectError;
}(Error));
exports.SGWTConnectError = SGWTConnectError;
//# sourceMappingURL=SGWTConnectError.js.map